// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__tXlCC","bigColWidth":"Table_bigColWidth__27gX2","biggerColWidth":"Table_biggerColWidth__33px2","row":"Table_row__fAtnD","col":"Table_col__3e89Q"};